var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 py-2 rounded-full",class:{
        'text-green-800 bg-green-100': _vm.iconType === 'success',
        'text-red-700 bg-red-100': _vm.iconType === 'fail',
        'text-blue-700 bg-blue-100': _vm.iconType === 'neutral',
    },attrs:{"title":"Data Pipeline"}},[_c('Icon',{class:{ 'w-4 h-4': _vm.dropdown, 'w-6 h-6': !_vm.dropdown },attrs:{"icon":"solar:cloud-upload-broken"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }